<template>
	<div class="wrap">
		<div class="public_head">
         <img :src="bannerUrl" alt="" class="banner">
	       <!-- <img src="/../../../static/images/public_banner.jpg" alt="" class="banner"> -->
	       <div class="public_head_text">
	         <!-- <p>安永复旦<br>最具潜力企业评选</p> -->
	       </div>
	    </div>
	
	</div>
</template>
<script>
	export default {
	  name: 'head',
	  data(){
	  	return{
	  		
	  	}
	  },
    props:['bannerUrl']
	}
</script>
<style>
  
</style>


// WEBPACK FOOTER //
// src/components/public/header.vue